import Link from "next/link";
import { usePathname } from "next/navigation";
import { useSession } from "@/lib/auth-react";
import { useSiteStatus } from "@/components/SiteStatusGate";

export default function NavLinks({ vertical = false }: { vertical?: boolean }) {
  const pathname = usePathname();
  const { data: session } = useSession();
  const {
    payments: { enabled: paymentsEnabled },
  } = useSiteStatus();

  const linkStyles =
    "text-sm md:text-base lg:text-base font-light text-white hover:text-gray-300";
  const activeLinkStyles =
    "text-sm md:text-base lg:text-base font-light text-[#F6C65A] active-underline";

  const containerClass = vertical ? "flex flex-col gap-4 " : "flex gap-8";

  const userRole = session?.user?.role;

  // 🔒 Hide everything for TEACHERS
  if (userRole === "TEACHER") {
    return null;
  }

  return (
    <nav className={containerClass}>
      <Link
        href="/find-a-teacher"
        className={
          pathname?.startsWith("/find-a-teacher") ? activeLinkStyles : linkStyles
        }
        data-testid="navFindTeacherLink"
      >
        Find a teacher
      </Link>
      {/* Library link hidden — page exists but not shown in nav */}
      <Link
        href="/how-it-works"
        className={pathname === "/how-it-works" ? activeLinkStyles : linkStyles}
        data-testid="navHowItWorksLink"
      >
        How it works
      </Link>
      {/* Hidden when payments are disabled — no live purchase flow. */}
      {paymentsEnabled && (
        <Link
          href="/packages"
          className={pathname === "/packages" ? activeLinkStyles : linkStyles}
          data-testid="navPackagesLink"
        >
          {session ? "Buy a Package" : "Packages"}
        </Link>
      )}

      {/* Show "Become a Teacher" only for Guests (not logged in) and Admins */}
      {(userRole === "ADMIN" || !session) && (
        <Link
          href="/become-a-teacher"
          className={
            pathname === "/become-a-teacher" ? activeLinkStyles : linkStyles
          }
          data-testid="navBecomeTeacherLink"
        >
          Become a teacher
        </Link>
      )}
    </nav>
  );
}
